module.exports = __webpack_public_path__ + "img/second-onboarding-banner.7923908a.png";